module.exports = __webpack_public_path__ + "static/media/opRun.f83e66f3.png";